export function calculateTip(subtotal, selection, customAmount) {
  const amount = selection === "custom" ? Number(customAmount || 0) : Number(subtotal) * Number(selection) / 100;
  return Number.isFinite(amount) && amount >= 0 ? Math.round((amount + Number.EPSILON) * 100) / 100 : 0;
}

export function readCheckoutTip(serialized, cart) {
  try {
    const saved = JSON.parse(serialized);
    if (!saved || saved.cart !== JSON.stringify(cart)) return 0;
    return calculateTip(0, "custom", saved.amount);
  } catch {
    return 0;
  }
}
